<div class="p-24">
  <h3 class="mat-h3">Login Notice</h3>
  <p class="mat-body-1">
    Set the notice message that will be shown to users after login. Leave blank to not show any
    notice.
  </p>

  <mat-form-field class="w-full">
    <textarea
      matInput
      [(ngModel)]="noticeContent"
      placeholder="Enter notice text here..."
      rows="5"
    ></textarea>
    <mat-hint>If left blank, no notice will be displayed after login.</mat-hint>
  </mat-form-field>

  <div class="d-flex justify-content-end m-t-16">
    <button mat-raised-button color="accent" (click)="save()">Save</button>
  </div>
</div>
